module.exports = __webpack_public_path__ + "static/media/school_13.287f9373.png";